import { toast } from "react-toastify";
import i18n from "i18next";
import { DashboardSummary } from "../../types";
import {
  ATTESTATO_DOC_TYPE_ID,
  BE_BASE_URL,
  BE_DASHBOARD_SUMMARY_ENDPOINT,
} from "../../utils/config";
import { axiosInstance } from "../../provider/authProvider";
import { RIEPILOGO_VUOTO } from "./riepilogo";

// Il riepilogo dei KPI (mancanti, validi, scaduti, in scadenza a 1/2/6 mesi)
// in una sola richiesta, calcolato dal backend con la stessa regola della
// lista attestati. Senza riepilogo la pagina resta usabile: toast e KPI a zero.
export function getDashboardSummary(): Promise<DashboardSummary> {
  return axiosInstance
    .get<DashboardSummary>(BE_BASE_URL + BE_DASHBOARD_SUMMARY_ENDPOINT, {
      params: { dTId: ATTESTATO_DOC_TYPE_ID },
    })
    .then((response) => response.data ?? RIEPILOGO_VUOTO)
    .catch(() => {
      toast.error(i18n.t("attestati-errore-conteggi"));
      return RIEPILOGO_VUOTO;
    });
}
